<template>
  <div class="page-appointment-container page-fullscreen-layout-container">
    <div class="reservation__container">
      <div class="reservation__title">
        <span>reservation</span>
        <span class="line">__</span>
        <span>预约</span>
      </div>
      <div class="reservation__main-body">
        <div class="body__header-container">
          <div
            class="header__item"
            :class="{
              active: reservationType === 'preach'
            }"
            @click="reservationType = 'preach'"
          >
            预约宣讲
          </div>
          <div
            class="header__item"
            :class="{
              active: reservationType === 'live'
            }"
            @click="reservationType = 'live'"
          >
            预约直播
          </div>
        </div>
        <div class="body__main">
          <preach
            :moldList="moldList"
            :company="storesList"
            v-if="moldList && reservationType === 'preach'"
            :typeId="typeId"
            @moldClick="getTypeId"
          ></preach>
          <live :timeline="timeline" v-else-if="moldList && reservationType === 'live'"></live>
        </div>
      </div>
    </div>
    <div class="cooperation__container appointment__child" style="display:none;">
      <div class="reservation__title scroll-up-to upObj">
        <span>cooperative business</span>
        <span class="line">__</span>
        <span>合作商家</span>
      </div>
      <div class="child__wrapper">
        <div class="cb-items-container">
          <div
            class="cb__item scroll-up-to upObj"
            v-for="(brand, index) in coBrands"
            :key="index"
            :style="{
              backgroundImage: `url('${brand}')`
            }"
          ></div>
        </div>
      </div>
    </div>
    <div class="preach_cover_container appointment__child">
      <div class="reservation__title scroll-up-to upObj">
        <span>previouS review</span>
        <span class="line">__</span>
        <span>全国一线城市材料宣讲</span>
      </div>
      <div class="child__wrapper">
        <div class="covers-container">
          <!-- <div class="cover__group" v-for="(group, index) in coverGroup" :key="index">
            <div
              class="group__item scroll-up-to upObj"
              v-for="(img, imgindex) in group.imgs"
              :key="imgindex"
            >
              <img :src="img.url" alt="" />
            </div>
          </div> -->
          <swiper class="swiper__wrapper" :options="sOptions">
            <swiper-slide class="swiper__slide" v-for="(item, index) in aSlides" :key="index">
              <img :src="item.src" alt="" />
            </swiper-slide>
          </swiper>
          <div class="page-gg-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import a1 from '@/assets/images/a-s-1.jpg';
import a2 from '@/assets/images/a-s-2.jpg';
import a3 from '@/assets/images/a-s-3.jpg';
import a4 from '@/assets/images/a-s-4.jpg';
import a5 from '@/assets/images/a-s-5.jpg';
import a6 from '@/assets/images/a-s-6.jpg';

import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import preach from './_ preach.vue';
import live from './_live.vue';
import 'swiper/css/swiper.css';

export default {
  components: {
    preach,
    live,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      moldList: null,
      storesList: null,
      company: [],
      typeId: 0,
      reservationType: 'preach',
      timeline: [],
      coBrands: [],
      coverGroup: [
        {
          imgs: [
            {
              url: `${process.env.VUE_APP_STATIC_PATH}/static/images/news/1.jpg`,
            },
            {
              url: `${process.env.VUE_APP_STATIC_PATH}/static/images/news/3.jpg`,
            },
          ],
        },
        {
          imgs: [
            {
              url: `${process.env.VUE_APP_STATIC_PATH}/static/images/news/2.jpg`,
            },
            {
              url: `${process.env.VUE_APP_STATIC_PATH}/static/images/news/4.jpg`,
            },
          ],
        },
      ],
      aSlides: [
        {
          src: a1,
        },
        {
          src: a2,
        },
        {
          src: a3,
        },
        {
          src: a4,
        },
        {
          src: a5,
        },
        {
          src: a6,
        },
      ],
      sOptions: {
        autoplay: true,
        loop: true,
        pagination: {
          el: '.page-gg-pagination',
        },
      },
    };
  },
  watch: {
    $route: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    async init() {
      this.$store.commit('openLoading');
      this.reservationType = 'preach';
      const moldRequest = await this.getMoldList();
      this.moldList = moldRequest.data.list;
      this.typeId = this.moldList['0'].id;
      const stores = await this.getStores();
      this.storesList = stores.data.list;
      const timelineRequest = await this.getTimeline();
      this.timeline = timelineRequest.data;
      // 合作商家
      const urls = [];
      for (let i = 1; i < 22; i += 1) {
        const url = `/static/images/co-brands/a${i}.jpg`;
        urls.push(url);
      }
      this.coBrands = urls;
      this.$store.commit('closeLoading');
    },
    getMoldList() {
      return this.$http.post('html/Propaganda/moldList');
    },
    getStores() {
      return this.$http.post('html/Propaganda/storeList', {
        mold_id: this.typeId,
      });
    },
    getTimeline() {
      return this.$http.post('html/Propaganda/timeList');
    },
    async getTypeId(val) {
      this.typeId = Number(val);
      this.$store.commit('openLoading');
      const stores = await this.getStores();
      this.storesList = stores.data.list;
      this.$store.commit('closeLoading');
    },
  },
};
</script>

<style></style>
